import { ErrorAndMaintenance } from "../views/errorAndMaintenance";

export const RouteError = () => {
  return (
    <ErrorAndMaintenance
      labelTitle="Oops! Page not found."
      labelDescription="We couldn't find the page you are looking for."
      isGoHome={true}
    />
  );
};
